import { DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, switchMap, timer } from 'rxjs';

import { EventType, GqlService } from '@shared/services/gql.service';

export const fetchInProgressEvents = (eventType: EventType, destroyRef: DestroyRef) => {
  const alreadyReportedTrackers = new Set<string>();
  const gqlService = inject(GqlService);
  const progressTrackerId = signal<null | string>(null);

  timer(0, 60000)
    .pipe(
      filter(() => !progressTrackerId()),
      switchMap(() =>
        gqlService.listEventsInProgress$({
          event_type: eventType,
        })
      ),
      takeUntilDestroyed(destroyRef)
    )
    .subscribe((queryResult) => {
      if (queryResult.success && queryResult.data?.length) {
        const { progress_tracker_id } = queryResult.data[0];

        // reporting the detected tracker conditionally here in case something goes wrong on the server-side
        if (!alreadyReportedTrackers.has(progress_tracker_id)) {
          alreadyReportedTrackers.add(progress_tracker_id);
          progressTrackerId.set(progress_tracker_id);
        }
      }
    });

  return progressTrackerId;
};
